import {Component, EventEmitter, Input, Output} from '@angular/core';


@Component({
    selector: 'app-icon-badge',
    imports: [],
    templateUrl: './icon-badge.component.html',
    styleUrl: './icon-badge.component.scss'
})
export class IconBadgeComponent {

  @Input() public style: 'home' | 'homeIcons' | 'barTop' | 'plainIcon' | 'plainIconSidePadding' | 'notification' | 'link' | 'noContent' | 'noContentSmall' | 'documents' | 'documentsFolder' | 'default' = 'home';
  @Input() public orientation: 'bottomRight' | 'topRight' | 'bottomLeft' | 'topLeft' = 'bottomRight';
  @Input() public icon: string = '';
  @Input() public color: 'default' | 'lightpurple' | 'pink' | 'orange' | 'aqua' | 'yellow' | 'blue' | 'darkorange' | 'cyan' | 'purple' | 'darkgreen' | 'skyblue' | 'red' | 'brightgreen' | 'asphalt' | 'darkblue' | 'primary'= 'default';
  @Input() public badge: boolean = false;
  @Input() public title: string = '';
  @Input() public danger: boolean = false;
  @Input() public alert: boolean = false;
  @Input() public screenReaderText: string = '';
  @Input() public class: string = '';

  @Input() public fontSize: 'fs-1' | 'fs-2' | 'fs-3' | 'fs-4' | 'fs-5' | 'fs-6' | 'fs-vl' | 'fs-normal' | 'fs-small' | 'fs-default' | null = null;
  @Input() public fontColor: 'text-muted' | 'text-white' | 'text-primary' | 'text-secondary' | 'text-lightpurple' | 'text-pink' | 'text-orange' | 'text-danger' | 'text-success' | 'text-warning' | 'text-aqua' | 'text-darkblue' | 'text-lightpurple' | 'text-darkgreen' | 'text-asphalt' | 'text-skyblue' | 'chat-other-fg-muted' | 'chat-own-fg' | 'chat-own-fg-muted' | null = null;
  @Input() public lineHeight: 'lh-base' | 'lh-1' = 'lh-base';

  // eslint-disable-next-line @angular-eslint/no-output-native, @typescript-eslint/no-explicit-any
  @Output() public  click: EventEmitter<any> = new EventEmitter<any>();
}
